module.exports = __webpack_public_path__ + "static/img/S108WP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/S108WP_1.png
// module id = hH+i
// module chunks = 0